import { PageConfig } from "../../../components/content-blocks/forms/customer-form-types";
import { choices } from "../config-generics/aeKao";

export const docsConfig: PageConfig[] = [
  {
    name: "docs",
    title: "Supporting Documents",
    questions: [
      {
        type: "file",
        name: "resources",
        title: `
          Please attach a copy of any resources or presentations used in your
          initiative.
        `,
        storeDataAsText: false,
        allowMultiple: true,
        maxSize: 10485760,
        waitForUpload: true,
      },
      {
        type: "file",
        name: "photos",
        title: "Please attach any relevant photographs.",
        storeDataAsText: false,
        allowMultiple: true,
        maxSize: 10485760,
        waitForUpload: true,
      },
    ],
  },
  {
    name: "photoPermission",
    title: "Photo Permission (Optional)",
    visibleIf: "!!{photos}",
    questions: [
      {
        name: "permission",
        title: `
          I give permission for the use of my photographs in Rangitāne reporting
          and promotional material.
        `,
        type: "radiogroup",
        choices,
        isRequired: true,
      },
    ],
  },
];
